import axios from "../axiosInstance";
import {
  FetchQuickBooksPeriodReportRequest,
  FetchQuickBooksPeriodReportResponse,
} from "./types";

export const fetchQuickBooksPeriodReport = async (
  requestData: FetchQuickBooksPeriodReportRequest,
): Promise<FetchQuickBooksPeriodReportResponse> => {
  const response = await axios.get<FetchQuickBooksPeriodReportResponse>(
    "/api/private/quickbooks-period-report",
    {
      params: requestData,
    },
  );
  return response.data;
};
